export default __webpack_public_path__ + "static/media/ethereumLogo2.568377bd.svg";